module.exports = __webpack_public_path__ + "069aebb52b279652bace9a6d602ab10f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2132_teaser_image.jpg
// module id = 610
// module chunks = 0